export const GET_TABLE_TO_SEND_EMAIL = 'GET_TABLE_TO_SEND_EMAIL'
export const GET_DATA_FOR_SELECT = 'GET_DATA_FOR_SELECT'

export const GET_EMAIL_TEMPLATE = 'GET_EMAIL_TEMPLATE'
export const GET_EMAIL_TEMPLATES = 'GET_EMAIL_TEMPLATES'
export const GET_EMAIL_TEMPLATES_FOR_SELECT = 'GET_EMAIL_TEMPLATES_FOR_SELECT'
export const CLEAR_TEMPLATE = 'CLEAR_TEMPLATE'

export const GET_EMAIL_HISTORY_TABLE = 'GET_EMAIL_HISTORY_TABLE'
export const GET_EMAIL_HISTORY_TOTAL_TABLE = 'GET_EMAIL_HISTORY_TOTAL_TABLE'
export const GET_EMAIL_HISTORY_READ_TABLE = 'GET_EMAIL_HISTORY_READ_TABLE'
export const GET_EMAIL_HISTORY_FILTERS = 'GET_EMAIL_HISTORY_FILTERS'
export const GET_EMAIL_HISTORY_CLICK_TABLE = 'GET_EMAIL_HISTORY_CLICK_TABLE'
export const GET_EMAIL_HISTORY_REPORTS = 'GET_EMAIL_HISTORY_REPORTS'

export const SET_LOADING = 'SET_LOADING'
